import { render, staticRenderFns } from "./CambioContrasena.vue?vue&type=template&id=4b1f174c&scoped=true"
import script from "./CambioContrasena.vue?vue&type=script&lang=ts"
export * from "./CambioContrasena.vue?vue&type=script&lang=ts"
import style0 from "./CambioContrasena.vue?vue&type=style&index=0&id=4b1f174c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f174c",
  null
  
)

export default component.exports